'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _useFocused = require('../hooks/useFocused');

var _useFocused2 = _interopRequireDefault(_useFocused);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FocusProvider = function FocusProvider(props) {
  return props.children((0, _useFocused2.default)(props));
};

FocusProvider.displayName = 'FocusProvider';

exports.default = FocusProvider;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/providers/FocusProvider.js
// module id = 522
// module chunks = 177